import React from 'react';
import { Neo, NeoGrid, Views } from '@singularsystems/neo-react';
import { observer } from 'mobx-react';
import { TextConstants } from '../../../Common/TextConstants';
import FileGroupingFileSpecImportProceduresVM from './FileGroupingFileSpecImportProceduresVM';
import FileGroupingFileSpecImportProcedureLookup from '../Models/Lookups/FileGroupingFileSpecImportProcedureLookup';
import ManageFileGroupingImportProcedureComponent from '../Components/ManageFileGroupingImportProcedureComponent';
import Loading from '../../../App/Components/Loading/Loading';
import { BrokerFileConfiguration, BrokerFileImportProcess } from '../../../AccessControl/Models/Commands/Security/Roles';

class FileGroupingFileSpecImportProceduresParams {
    public fileGroupingFileSpecID = {};
    public fileGroupingID = {};
    public staticFileSpecID = {};
}

@observer
export default class FileGroupingFileSpecImportProceduresView extends Views.ViewBase<FileGroupingFileSpecImportProceduresVM, FileGroupingFileSpecImportProceduresParams> {
    public static params = new FileGroupingFileSpecImportProceduresParams();

    public initialise() {
        this.viewModel.initialise(
            Number(this.viewParams.fileGroupingFileSpecID.value),
            Number(this.viewParams.fileGroupingID.value),
            Number(this.viewParams.staticFileSpecID.value));
    }
    constructor(props: unknown) {
        super("File Grouping File Spec Import Procedures", FileGroupingFileSpecImportProceduresVM, props);
    }

    public render() {
        return (
            <div>
                {(this.viewModel.taskRunner.isBusy) && <Loading />}
                {this.viewModel.displayManageFileGroupingImportProcedureComponent &&
                    <ManageFileGroupingImportProcedureComponent
                        viewModel={this.viewModel.manageFileGroupingImportProcedureComponentVM}
                        onSave={() => this.viewModel.saveFileGroupingFileSpec()}
                        onCancel={() => this.viewModel.cancel()} />
                }

                {!this.viewModel.displayManageFileGroupingImportProcedureComponent &&
                    <Neo.Card title={TextConstants.Titles.BrokerFileSpecImportProcedures} className="m-1">
                        {this.viewModel.authorisationService.hasRole(BrokerFileImportProcess.AddBrokerFileImportProcess) &&
                            <div className="row">
                                <div className="col text-right">
                                    <Neo.Button
                                        variant="primary"
                                        onClick={() => this.viewModel.manageFileSpecImportProcedure()}
                                        disabled={this.viewModel.fileGroupingFileSpecImportProcedureCriteria.staticFileSpecID === null}
                                    >{TextConstants.Buttons.AddNewBrokerFileSpecImportProcedure}</Neo.Button>
                                </div>
                            </div>
                        }

                        <div>
                            <Neo.Form model={this.viewModel.fileGroupingFileSpecImportProcedureCriteria}
                                onSubmit={() => this.viewModel.fileGroupingFileSpecImportProcedureCriteria.meta.searchCriteria.value === "" ? this.viewModel.pageManager.refreshData() : this.viewModel.clearSearch()}>
                                <div className="row">
                                    <div className="col-lg-4">
                                        <Neo.FormGroup bindContext={this.viewModel.fileGroupingFileSpecImportProcedureCriteria.meta.serviceProviderGroupingName} label={TextConstants.Labels.Broker}>
                                            <Neo.AutoCompleteDropDown
                                                itemSource={this.viewModel.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria}
                                                bind={this.viewModel.fileGroupingFileSpecImportProcedureCriteria.meta.staticServiceProviderFileGroupingID}
                                                bindDisplay={this.viewModel.fileGroupingFileSpecImportProcedureCriteria.meta.serviceProviderGroupingName}
                                                displayMember={"serviceProviderGroupingName"}
                                                onItemSelected={() => this.viewModel.setFileSpecDropdown()}
                                                items={this.viewModel.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria(" ").then((arr) => arr.data
                                                .sort((x,y)=> x.serviceProviderGroupingName.localeCompare(y.serviceProviderGroupingName)))}
                                            />
                                        </Neo.FormGroup>
                                    </div>
                                    <div className="col-lg-4">
                                        <Neo.FormGroup bindContext={this.viewModel.fileGroupingFileSpecImportProcedureCriteria.meta.fileTypeConcatenated} label={TextConstants.Labels.FileType}>
                                            <Neo.AutoCompleteDropDown
                                                itemSource={this.viewModel.fileGroupingFileSpecApiClient.getFileTypeListByCriteria}
                                                bind={this.viewModel.fileGroupingFileSpecImportProcedureCriteria.meta.staticFileSpecID}
                                                bindDisplay={this.viewModel.fileGroupingFileSpecImportProcedureCriteria.meta.fileTypeConcatenated}
                                                displayMember={"propertiesConcatenated"}
                                                onItemSelected={() => this.viewModel.onFileSpecChange()}
                                                items={this.viewModel.fileGroupingFileSpecApiClient.getFileTypeListByCriteria(" ").then((arr) => arr.data.slice(0, 10)
                                                .sort((x,y)=> x.propertiesConcatenated.localeCompare(y.propertiesConcatenated)))}
                                            />
                                        </Neo.FormGroup>
                                    </div>
                                </div>
                            </Neo.Form>
                        </div>
                        <div>
                            <Neo.Pager pageManager={this.viewModel.pageManager} pageControlProps={{ pageSizeLabel: "Show: " }}>
                                <div className="horizontalScroll inner-container">
                                    <NeoGrid.Grid<FileGroupingFileSpecImportProcedureLookup> className={"table-striped"}>
                                        {(item, meta) => (
                                            <NeoGrid.RowGroup>
                                                <NeoGrid.Row key={item.fileGroupingFileSpecImportProcedureId} className="twoRowsPerGridItem">
                                                    <NeoGrid.Column display={meta.stockbrokerName} />
                                                    <NeoGrid.Column display={meta.fileType} />
                                                    <NeoGrid.Column display={meta.activeStartDate} />
                                                    <NeoGrid.Column display={meta.activeEndDate} />
                                                    <NeoGrid.Column display={meta.storedProcedure} colSpan={2} />
                                                    <NeoGrid.Column display={meta.process} />
                                                    <NeoGrid.Column display={meta.priority} />

                                                </NeoGrid.Row>
                                                <NeoGrid.Row className="twoRowsPerGridItem">
                                                    <NeoGrid.Column display={meta.filterClause} colSpan={4} />
                                                    <NeoGrid.Column display={meta.joinClause} colSpan={3} />
                                                    {this.viewModel.authorisationService.hasRole(BrokerFileImportProcess.Edit) &&
                                                        <NeoGrid.ButtonColumn label={TextConstants.Labels.Edit} className="text-center">
                                                            <Neo.Button
                                                                onClick={() => this.viewModel.manageFileSpecImportProcedure(item)}
                                                                variant="primary" isOutline className="btn-small">
                                                                <i className="fa fa-edit"></i>
                                                            </Neo.Button>
                                                        </NeoGrid.ButtonColumn>
                                                    }
                                                </NeoGrid.Row>
                                            </NeoGrid.RowGroup>

                                        )}
                                    </NeoGrid.Grid>
                                </div>
                            </Neo.Pager>
                        </div>
                        {this.viewModel.authorisationService.hasRole(BrokerFileConfiguration.Access) &&
                            <div className="row">
                                <div className="col">
                                    <Neo.Button
                                        onClick={() => this.viewModel.onBack()}
                                        variant="secondary"
                                    >{TextConstants.Buttons.Back}</Neo.Button>
                                </div>
                            </div>
                        }
                    </Neo.Card>
                }
            </div>
        );
    }
}